import { Button, Group, TextInput } from '@mantine/core'
import type { FC } from 'react'
import React, { useState } from 'react'

interface DropdownInputProps {
    placeholder?: string
    confirmText?: string
    onConfirm: (value: string) => void
}

export const DropdownInput: FC<DropdownInputProps> = ({ onConfirm, placeholder, confirmText }) => {
    const [value, setValue] = useState<string | undefined>()
    return (
        <Group style={{ gap: 12, padding: 0 }}>
            <TextInput value={value} onChange={e => setValue(e.target.value)} placeholder={placeholder} />
            <Button px={7} disabled={!value} onClick={() => value && onConfirm(value)}>
                {confirmText}
            </Button>
        </Group>
    )
}
